<template>
  <svg
    width="203"
    height="130"
    viewBox="0 0 203 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M202.256 74.877V82.7386L121.67 129.604V121.697L202.256 74.877Z"
        fill="#8B3F4E"
      />
      <path
        id="Vector_2"
        d="M0 51.4727L121.67 121.697V129.603L0 59.3908L0 51.4727Z"
        fill="#6E3037"
      />
      <path
        id="Vector_3"
        d="M202.267 70.2246L202.256 74.8783L121.67 121.698L121.681 117.044L202.267 70.2246Z"
        fill="#8BCE3A"
      />
      <path
        id="Vector_4"
        d="M92.7669 7.02579L12.181 53.8455L0.0117188 46.8198L80.5976 0L92.7669 7.02579Z"
        fill="#8BCE3A"
      />
      <path
        id="Vector_5"
        d="M117.105 21.0668L36.5076 67.8866L24.3496 60.8608L104.936 14.041L117.105 21.0668Z"
        fill="#8BCE3A"
      />
      <path
        id="Vector_6"
        d="M141.432 35.1063L60.846 81.926L48.6768 74.9116L129.263 28.0918L141.432 35.1063Z"
        fill="#8BCE3A"
      />
      <path
        id="Vector_7"
        d="M165.771 49.1586L85.1849 95.9784L73.0156 88.9526L153.602 42.1328L165.771 49.1586Z"
        fill="#8BCE3A"
      />
      <path
        id="Vector_8"
        d="M190.098 63.1977L109.512 110.017L97.3428 102.992L177.94 56.1719L190.098 63.1977Z"
        fill="#8BCE3A"
      />
      <path
        id="Vector_9"
        d="M104.936 14.0399L24.3499 60.8596L12.1807 53.8451L92.7666 7.02539L104.936 14.0399Z"
        fill="#A3E743"
      />
      <path
        id="Vector_10"
        d="M129.263 28.0922L48.677 74.9119L36.5078 67.8862L117.105 21.0664L129.263 28.0922Z"
        fill="#A3E743"
      />
      <path
        id="Vector_11"
        d="M153.602 42.1332L73.0159 88.953L60.8467 81.9272L141.433 35.1074L153.602 42.1332Z"
        fill="#A3E743"
      />
      <path
        id="Vector_12"
        d="M177.94 56.1727L97.3425 102.992L85.1846 95.978L165.77 49.1582L177.94 56.1727Z"
        fill="#A3E743"
      />
      <path
        id="Vector_13"
        d="M202.267 70.2231L121.681 117.043L109.512 110.017L190.098 63.1973L202.267 70.2231Z"
        fill="#A3E743"
      />
      <path
        id="Vector_14"
        d="M0.0112995 46.8203L121.681 117.044L121.67 121.698L0 51.474L0.0112995 46.8203Z"
        fill="#01A748"
      />
      <path
        id="Vector_15"
        d="M192.482 69.694L185.725 65.797L88.3937 9.61332L81.6368 5.71638C81.0719 5.38881 80.1679 5.38881 79.6143 5.71638L72.9025 9.61332L63.5016 15.0803L54.1007 20.536L35.2988 31.4588L25.8979 36.9258L16.4969 42.3815L9.7739 46.2897C9.22024 46.6173 9.23154 47.1369 9.7852 47.4645L16.5421 51.3614L113.873 107.534L120.63 111.431C121.195 111.758 122.088 111.758 122.653 111.431L129.376 107.523L138.777 102.067L148.178 96.5998L166.98 85.6771L176.381 80.2214L185.782 74.7543L192.493 70.8574C193.047 70.5298 193.047 70.0102 192.493 69.6827L192.482 69.694ZM80.6312 7.46718L85.2752 10.1442C82.5182 11.2625 78.8007 11.2625 76.0211 10.1442L80.6312 7.46718ZM55.1176 22.2868L61.8745 26.1838L45.0839 35.9431L38.327 32.0461L55.1176 22.2868ZM36.3157 33.2096L44.0896 37.6939C44.6545 38.0214 45.5585 38.0214 46.1121 37.6939L64.914 26.7712C65.4677 26.4436 65.4564 25.924 64.9027 25.6077L57.1288 21.1234L64.5185 16.8311L81.4221 26.5904L74.4392 30.6455L52.8125 43.2061L45.8296 47.2612L28.926 37.5019L36.3157 33.2096ZM70.3828 40.8227C66.7219 42.9463 61.6146 43.8612 56.5978 43.3416L74.6878 32.8255C75.5917 35.7285 74.0324 38.6879 70.3715 40.8114L70.3828 40.8227ZM17.4574 49.5428L12.8134 46.8658L17.4235 44.1888C19.3669 45.7927 19.3782 47.9389 17.4574 49.5428ZM19.5025 50.7176C22.4968 48.4472 22.4855 45.2731 19.4573 43.0028L26.9148 38.6653L44.8353 49.0007C45.4003 49.3282 46.2929 49.3169 46.8579 49.0007L54.2476 44.7084C60.7559 45.7701 67.6484 44.7536 72.428 41.9749C77.2188 39.1962 78.9476 35.1976 77.0832 31.4362L84.4729 27.1439C85.0266 26.8163 85.0379 26.2967 84.4729 25.9692L66.5524 15.6338L74.0098 11.2963C77.942 13.0471 83.4334 13.0359 87.3316 11.2963L134.042 38.2587L113.173 50.3787C105.862 46.7529 94.8456 46.9336 87.9644 50.9322C81.0831 54.9308 80.812 61.3127 87.083 65.5372L66.2134 77.6573L19.5025 50.695V50.7176ZM113.184 52.7395C118.348 56.3088 118.065 61.6516 112.292 64.9951C106.529 68.3498 97.3088 68.5305 91.1168 65.5485L113.173 52.7282L113.184 52.7395ZM89.0943 64.3851C83.9305 60.8157 84.213 55.473 89.9869 52.1295C95.7608 48.7747 104.97 48.594 111.162 51.576L89.1056 64.3964L89.0943 64.3851ZM121.636 109.669L116.992 106.992C119.76 105.873 123.478 105.873 126.246 106.992L121.636 109.669ZM147.15 94.849L140.393 90.9521L157.183 81.1928L163.94 85.0897L147.15 94.849ZM165.951 83.9263L158.178 79.442C157.613 79.1144 156.72 79.1144 156.166 79.442L137.364 90.3647C136.811 90.6923 136.8 91.2119 137.364 91.5394L145.138 96.0237L137.749 100.316L120.845 90.5567L127.828 86.5016L149.455 73.9298L156.438 69.8747L173.341 79.634L165.951 83.9263ZM131.884 76.3131C135.545 74.1896 140.653 73.2746 145.669 73.7942L127.579 84.3103C126.675 81.4074 128.235 78.448 131.896 76.3244L131.884 76.3131ZM175.352 78.4593L157.443 68.1239C156.878 67.7963 155.974 67.7963 155.421 68.1239L148.031 72.4162C141.534 71.3544 134.641 72.371 129.851 75.1497C125.071 77.9284 123.331 81.927 125.195 85.6884L117.806 89.9807C117.252 90.3082 117.252 90.8278 117.806 91.1554L135.715 101.491L128.257 105.828C124.325 104.089 118.834 104.089 114.936 105.828L68.2247 78.8659L89.0943 66.7458C96.4049 70.3604 107.422 70.191 114.303 66.1924C121.184 62.1938 121.455 55.8118 115.184 51.5986L136.054 39.4786L182.765 66.4409C179.77 68.7113 179.793 71.8853 182.81 74.1557L175.352 78.4931V78.4593ZM184.844 72.9471C182.912 71.3431 182.889 69.1857 184.81 67.593L189.454 70.27L184.844 72.9471Z"
        fill="white"
      />
    </g>
  </svg>
</template>
